import { ShiftsSwapShiftFragment } from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import SwapShift from 'modules/shift_management/store/internal//models/SwapShift'

class SwapShifts extends Collection<SwapShift> {
  constructor(swapShift: SwapShift[]) {
    super(swapShift)

    makeObservable(this, {
      _groupedByCurrentShift: computed,
      _groupedByRequestedShift: computed,
      pending: computed,
      approved: computed,
    })
  }

  model() {
    return SwapShift
  }

  get cacheKey(): string {
    return 'swapShifts'
  }

  static buildFromRequest(swapShifts: ShiftsSwapShiftFragment[]): SwapShifts {
    const swapShiftsObjects = swapShifts.map((swapShift) => SwapShift.buildFromRequest(swapShift))

    return new SwapShifts(swapShiftsObjects)
  }

  get _groupedByCurrentShift(): Record<number, SwapShift[]> {
    return groupBy(this.models, (plannedBreak) => plannedBreak.currentShiftId)
  }

  get _groupedByRequestedShift(): Record<number, SwapShift[]> {
    return groupBy(this.models, (plannedBreak) => plannedBreak.requestedShiftId)
  }

  get pending(): SwapShift[] {
    return this.models.filter(({ status }) => status === SwapShift.types.pending)
  }

  get approved(): SwapShift[] {
    return this.models.filter(({ status }) => status === SwapShift.types.approved)
  }

  filterByCurrentShift(shiftId: number): SwapShifts {
    return new SwapShifts(this._groupedByCurrentShift[shiftId] || [])
  }

  filterByRequestedShift(shiftId: number): SwapShifts {
    return new SwapShifts(this._groupedByRequestedShift[shiftId] || [])
  }
}

export default SwapShifts
